// @/services/CategoriesClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const categoryOptions = {
  baseUrl: `${BACK_END_URL}/category`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class CategoriesClient extends CandyClient {
  constructor() {
    super(categoryOptions);
  }

  async getAll() {
    return this.get('/list');
  }

  async createCategory(dto) {
    return this.post('/create', dto, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  async updateCategory(id, dto) {
    return this.put(`/update/${id}`, dto, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  async deleteCategory(id) {
    return this.delete(`/delete/${id}`, null, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`
      }
    });
  }
}
